import Vue from 'vue'
import Element from 'element-ui'
// import '../assets/styles/index.scss'

Vue.use(Element)
